// assets/menu-hover.js

document.addEventListener("DOMContentLoaded", () => {

  // Desktop only
  if (window.innerWidth < 990) return;

  // ONLY target desktop menu items
  const menuItems = document.querySelectorAll(
    '.header__inline-menu details'
  );

  menuItems.forEach((item) => {

    const summary = item.querySelector("summary");

    if (!summary) return;

    let timeout;

    // Open on hover
    item.addEventListener("mouseenter", () => {
      clearTimeout(timeout);
      item.setAttribute("open", "");
    });

    // Close on leave
    item.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        item.removeAttribute("open");
      }, 100);
    });

    // Allow normal Dawn behavior
    summary.addEventListener("click", (e) => {

      // Desktop only
      if (window.innerWidth >= 990) {
        e.preventDefault();
      }

    });

  });

});